import { createReader } from './utils/reader.js';
export function decodeMessage(buf, codec) {
    const reader = createReader(buf);
    return codec.decode(reader);
}
//# sourceMappingURL=decode.js.map